import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, normalizeStyle as _normalizeStyle, createVNode as _createVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { class: "ml-auto hidden overflow-hidden rounded-4 border border-black-200 tablet:flex tablet:flex-row-reverse" }
const _hoisted_2 = ["onClick"]
const _hoisted_3 = { class: "ml-auto flex flex-row-reverse overflow-hidden rounded-4 border border-black-200 tablet:hidden" }
const _hoisted_4 = ["onClick"]

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_v_icon = _resolveComponent("v-icon")

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      (_openBlock(), _createElementBlock(_Fragment, null, _renderList(3, (n) => {
        return _createElementVNode("button", {
          key: n,
          type: "button",
          class: _normalizeClass(["group aspect-square w-40 border-r first:border-none hover:bg-black-300", 
        $data.currentNumOfColumns === n + 2
          ? 'pointer-events-none border-black-200 bg-black-100'
          : 'border-black-100 bg-white'
      ]),
          onClick: $event => ($options.updateNumOfColumns(n + 2))
        }, [
          _createVNode(_component_v_icon, {
            icon: `${n + 2}columns`,
            class: "m-auto",
            height: 18,
            style: _normalizeStyle(
          $data.currentNumOfColumns === n + 2 && 'fill: var(--collection-grid-columns-active-toggle)'
        )
          }, null, 8, ["icon", "style"])
        ], 10, _hoisted_2)
      }), 64))
    ]),
    _createElementVNode("div", _hoisted_3, [
      (_openBlock(), _createElementBlock(_Fragment, null, _renderList(2, (n) => {
        return _createElementVNode("button", {
          key: n,
          type: "button",
          class: _normalizeClass(["group aspect-square w-32 border-r first:border-none", 
        $data.currentNumOfColumns === n
          ? 'pointer-events-none border-black-200 bg-black-100'
          : 'border-black-100 bg-white'
      ]),
          onClick: $event => ($options.updateNumOfColumns(n))
        }, [
          _createVNode(_component_v_icon, {
            icon: "2columns",
            class: "m-auto",
            height: 18,
            rotated: n === 1,
            style: _normalizeStyle($data.currentNumOfColumns === n && 'fill: var(--collection-grid-columns-active-toggle)')
          }, null, 8, ["rotated", "style"])
        ], 10, _hoisted_4)
      }), 64))
    ])
  ], 64))
}